import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as momentTz from 'moment-timezone';
import DateUtils from 'src/app/shared/utils/date.utils';
import { RangeValidation } from '../models';

/**
 * Validates that the date + time selected is between a range of duration from now (not dates)
 */
export const dateTimeScheduleRangeValidator = (rangeValidation: RangeValidation): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const { value } = control;
    const { date, time, timezone } = value;
    if (!date || !time || !timezone) {
      return null;
    }
    const scheduleLocaleTime = DateUtils.createDate({
      year: date.get('year'),
      month: date.get('month'),
      date: date.get('date'),
      hour: time.h,
      minute: time.m,
      second: 0,
      timezone,
    });

    const localeDateTimeMin = momentTz().tz(timezone).add(rangeValidation.min.amount, rangeValidation.min.unit);
    const localeDateTimeMax = momentTz().tz(timezone).add(rangeValidation.max.amount, rangeValidation.max.unit);

    const invalid = !scheduleLocaleTime.isBetween(localeDateTimeMin, localeDateTimeMax);

    return invalid ? { range: true } : null;
  };
};
